/**
 * Sets all nested properties matching the key name to the specified value.
 * This function traverses the object recursively and updates every matching key.
 *
 * @param object - The object to be modified.
 * @param keyName - The name of the key(s) to set the value for.
 * @param value - The value to set for the matching keys.
 */
export const setAllMatchingKeys = (object: any, keyName: string, value: any): void => {
  if (typeof object !== 'object' || object === null) return;

  for (const key in object) {
    if (!object.hasOwnProperty(key)) continue;

    if (key === keyName) {
      object[key] = value;
    } else if (typeof object[key] === 'object') {
      setAllMatchingKeys(object[key], keyName, value);
    }
  }
};
